/**
 * Step Configuration
 *
 * Centralized configuration for wizard steps including:
 * - Step metadata (title, description)
 * - Button label logic
 * - Icon components
 */

import { FacilitiesIcon, UsersIcon, CleaningIcon } from '../components/icons';

/**
 * Generates button label for Step 1 based on facilities count
 */
export const getStep1ButtonLabel = (stats) => {
  const hasFacilities = stats?.facilitiesCount > 0;
  return hasFacilities ? 'Edit' : 'Start';
};

/**
 * Generates button label for Step 2 based on users count
 */
export const getStep2ButtonLabel = (stats) => {
  const hasUsers = stats?.usersCount > 0;
  return hasUsers ? 'Manage' : 'Invite';
};

/**
 * Generates button label for Step 3 based on standards configuration
 */
export const getStep3ButtonLabel = (stats) => {
  const hasStandards = stats?.standardsConfigured > 0;
  return hasStandards ? 'Review' : 'Define';
};

/**
 * Step configurations
 */
export const STEP_CONFIGS = [
  {
    stepNumber: 1,
    title: 'Create Facilities & Locations',
    copy: 'Tell us where cleaning will happen.',
    defaultButtonLabel: 'Start',
    getButtonLabel: getStep1ButtonLabel,
    IconComponent: FacilitiesIcon,
  },
  {
    stepNumber: 2,
    title: 'Invite New Users to your Team',
    copy: 'Add colleagues and set their roles.',
    defaultButtonLabel: 'Invite',
    getButtonLabel: getStep2ButtonLabel,
    IconComponent: UsersIcon,
  },
  {
    stepNumber: 3,
    title: 'Set Cleaning Standards',
    copy: (
      <>
        <p className="mb-0">Define the rules all facilities</p>
        <p>must follow.</p>
      </>
    ),
    defaultButtonLabel: 'Define',
    getButtonLabel: getStep3ButtonLabel,
    IconComponent: CleaningIcon,
  },
];
